// extracted by mini-css-extract-plugin
module.exports = {"hero":"home_hero__2Sln4"};